import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useRouter } from 'next/router';
import { JsonLd } from '../../JsonLd';
import type { LandingBrand } from '../../../graphql/types';
import { SCHEMA_CONTEXT, SchemaOrgType } from '../../../seo.constants';
import CONFIG from '../../../config';

interface PashaLandingSchemaProps {
  landingBrand: LandingBrand;
}

export const PashaLandingSchema: React.FC<PashaLandingSchemaProps> = ({
  landingBrand
}) => {
  const { t, i18n } = useTranslation();
  const { asPath } = useRouter();

  const origin = useMemo(() => {
    const langPrefix = i18n.language === 'ru' ? 'ru.' : '';
    return `${CONFIG.protocol}://${langPrefix}${CONFIG.host}`;
  }, [i18n.language]);

  const currPath = origin + asPath;

  const defaultSeoImages = [
    '/static/images/pasha/seo_images/pasha-real-estate-ritz-carlton.jpg',
    '/static/images/pasha/seo_images/pasha-real-estate-crescent.jpg',
    '/static/images/pasha/seo_images/pasha-real-estate-port-baku.jpg'
  ];

  const images =
    landingBrand.placements
      ?.map(p => p.coverUrl)
      .filter(Boolean)
      .slice(0, 3) || defaultSeoImages;

  const jsonLd = useMemo(
    () => ({
      '@context': SCHEMA_CONTEXT,
      '@type': SchemaOrgType.HomeAndConstructionBusiness,
      '@id': currPath,
      name: 'Pasha Real Estate',
      description: t('pasha.seo_description'),
      url: currPath,
      image: images.length > 0 ? images : defaultSeoImages,
      address: {
        '@type': SchemaOrgType.PostalAddress,
        streetAddress: '147 Neftchilar Ave',
        addressLocality: 'Baku',
        addressCountry: 'AZ',
        addressRegion: 'Baku',
        postalCode: 'AZ1173'
      },
      telephone: '+994512013232',
      aggregateRating: {
        '@type': SchemaOrgType.AggregateRating,
        ratingValue: 94,
        bestRating: 100,
        worstRating: 0,
        ratingCount: 17
      },
      priceRange: 'от 335000 AZN'
    }),
    [currPath]
  );

  return <JsonLd data={jsonLd} />;
};
